import { Identifiable, Project, ProjectResource } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedResource, Linker } from "../linkers/types";

type Response = {
  _embedded: {
    projectMembers: LinkedResource<Identifiable<ProjectResource>>[];
  };
};

function getProjectResources(httpClient: HttpClient, linker: Linker) {
  return (project: Identifiable<Project>) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/projects/${project.uuid}/resources?projection=details&size=999999`,
        method: HttpMethods.GET,
      })
      .then(({ _embedded }) => _embedded.projectMembers)
      .then((members) =>
        members.map((member) => ({
          ...member,
          resource: {
            ...member.resource,
            tags: member.resource.tags.map((t) =>
              typeof t === "string" ? { name: t } : t,
            ),
          },
          project,
          deactivated: member.deactivated,
        })),
      )
      .catch((e) => Promise.reject({ ...e, message: e.detail || "" }));
}

export { getProjectResources };
